/**
 * Choosing which of an EPUB's chapters to add: the parts with no React in them
 * (ADR-0052). The server read the file and judged each chapter's length; this
 * only decides what goes back.
 */
import type { EmphasisRange, ImportedChapter } from "../api";

/** Every chapter starts ticked, except one the server says is too long to add. */
export function initiallyKept(chapters: ImportedChapter[]): boolean[] {
  return chapters.map((c) => !c.too_long);
}

/**
 * The chapters to send, in the file's order. A chapter the file left untitled
 * is named by its place in the file — "Chapter 3" — because the server refuses
 * an empty title and names nothing itself.
 */
export function chaptersToAdd(
  chapters: ImportedChapter[],
  kept: boolean[],
  untitled: (position: number) => string,
): { title: string; body: string; emphasis?: EmphasisRange[] }[] {
  // The emphasis goes back as it came (ADR-0205); the server checks it again.
  return chapters.flatMap((c, i) =>
    kept[i] && !c.too_long
      ? [{ title: c.title.trim() || untitled(i + 1), body: c.body, emphasis: c.emphasis }]
      : [],
  );
}
